import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { PrazoPlanoSaudeModel } from "../model/prazo-plano-saude.model";

@Injectable()
export class PrazoPlanoSaudeService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Prazo Plano de Saúde por id
     * @param id ID da Prazo Plano de Saúde
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "plano-saude/prazo/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Prazo Plano de Saúde
     * @param id ID da Prazo Plano de Saúde
     */
    getAll(params: Record<string, unknown>): Observable<ApiPaginationResponseDataNonNullable<PrazoPlanoSaudeModel>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<PrazoPlanoSaudeModel>>(
            this.utilitesService.urlPrefix + "plano-saude/prazo" + env,
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }

    /**
     * Lista de Prazo Plano de Saúde
     * @param id ID da Prazo Plano de Saúde
     */
    search(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "plano-saude/prazo/search" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Delete de Prazo Plano de Saúde
     * @param id ID da Prazo Plano de Saúde
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "plano-saude/prazo/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Prazo Plano de Saúde
     * @param params Json Prazo Plano de Saúde
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + "plano-saude/prazo", JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza Prazo Plano de Saúde
     * @param params Json Prazo Plano de Saúde
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(this.utilitesService.urlPrefix + "plano-saude/prazo/" + id, JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }
}
